import React from 'react';
import Lightbox from 'src/components/lightbox/Lightbox';
import { getFileType, getFileUrl } from 'src/utils/fileUploadUtils';

interface IFullScreenViewerProps {
  isOpen: boolean;
  index: number;
  files: Array<File | string>;
  accept: Record<string, any>;
  onClose: () => void;
}

const FullScreenViewer: React.FC<IFullScreenViewerProps> = ({
  isOpen,
  index,
  files,
  accept,
  onClose,
}) => {
  return (
    <Lightbox
      open={isOpen}
      close={onClose}
      index={index}
      disabledVideo={false}
      slides={files.map((file) => {
        const fileType = getFileType(file, accept);
        const fileURL = getFileUrl(file);

        if (fileType.type === 'video') {
          return {
            type: 'video',
            sources: [
              {
                src: fileURL,
                type: 'video/mp4',
              },
            ],
            autoPlay: false,
            controls: true,
            playsInline: true,
          };
        }
        return { src: fileURL };
      })}
    />
  );
};

export default FullScreenViewer;
